import { markupBlocks } from './custom-blocks-markup';
import { platformBlocks } from './custom-blocks-platform';
import { actionBlocks } from './custom-blocks-action';
import { inputBlocks } from './custom-blocks-input';
/** The block library: every family merged. `BLOCKS` is the single list the schema, the palette, the catalog and the runtime read. */
import { contentBlocks } from './custom-blocks-content';
import { dataBlocks } from './custom-blocks-data';
import { layoutBlocks } from './custom-blocks-layout';

export const BLOCKS = {
  ...markupBlocks,
  ...platformBlocks,
  ...actionBlocks,
  ...inputBlocks,
  ...layoutBlocks,
  ...contentBlocks,
  ...dataBlocks,
} as const;

export type BlockType = keyof typeof BLOCKS;
export const BLOCK_TYPES = Object.keys(BLOCKS) as BlockType[];
export const isBlockType = (type: string): type is BlockType => Object.prototype.hasOwnProperty.call(BLOCKS, type);
